/**
 * Bulk product cataloch for CLS-SE.
 * Mock data — no backend. Keyed by slug.
 *
 * NOTE (placeholder): reuses ABC-SE product images until CLS-specific
 * photography is available. Swedish slugs are kept for now so the two
 * brands share URL patterns; swap to Danish slugs once the backend /
 * cataloch ships Danish content.
 */
import bulkFest from '../../../../assets/abc-se/accessories/party-overall.jpg';
import bulkVogn from '../../../../assets/abc-se/accessories/standard-overall.jpg';

export const BULK_PRODUCTS = {
  partyoverallen: {
    slug: 'partyoverallen',
    name: 'Festoverallen',
    price: '159:-',
    priceRaw: 159,
    description:
      'Klassisk overall i 100% bomull med dold knappstängning. Särskilt anpassad til färgning. Dold knappstängning fram. To fickor fram. Höger ficka har dragkedja. Regelficka på höger ben. Klapficka på vänster ben. Justerbar resår i midjan. Öglor i midjan. Förstärkt ögla på höger ben.',
    images: [
      { src: bulkFest, alt: 'Festoverallen' },
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    minPerSize: 0,
    minTotal: 10,
  },
  flakoverallen: {
    slug: 'flakoverallen',
    name: 'Vognoverallen',
    price: '159:-',
    priceRaw: 159,
    description:
      'Hållbar standard-overall designad til vognparader och utomhusaktiviteter. 100% bomull med förstärkede sömmar, justerbar midjalinje, flera fickor til användningsområden och et klassisk studentlook. Perfekt grund for färgning och anpassning.',
    images: [
      { src: bulkVogn, alt: 'Vognoverallen' },
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    minPerSize: 0,
    minTotal: 10,
  },
};

export const getBulkProduct = (slug) => BULK_PRODUCTS[slug] ?? null;
